"use strict";

export function initInScope ($scope) {
    let $slider = $scope.find('.js-logo-slider__wrapper');

    import('slick-carousel').then(function () {
        $slider.each(function () {
            let $container = $(this);
            let $mainSlider = $container.find('.js-logo-slider');

            $mainSlider.slick({
                slidesToShow: 6,
                slidesToScroll: 1,
                initialSlide: 0,
                nextArrow: '<button type="button" class="btn-no-styling slick-next slider__arrow logo-slider__arrow" aria-label="Next"><span class="slider__arrow__icon icon icon-arrow-down icon-rotate-270"></span></button>',
                prevArrow: '<button type="button" class="btn-no-styling slick-prev slider__arrow logo-slider__arrow" aria-label="Previous"><span class="slider__arrow__icon icon icon-arrow-down icon-rotate-90"></span></button>',
                swipeToSlide: true,
                infinite: false,
                sliderWrapper:$container,
                appendArrows: $container.find('.js-slider__arrow-wrapper'),
                responsive: [
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 1,
                            infinite: false,
                            initialSlide: 0
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1.2,
                            slidesToScroll: 1,
                            infinite: false,
                            initialSlide: 0
                        }
                    }
                ]
            });
        });
    });
}